@if (visible) {
  <div class="debug-modal-overlay" (click)="onOverlayClick($event)">
    <div class="debug-modal">
      <h2 class="debug-modal__title">DEBUG MENU</h2>

      <div class="debug-modal__section">
        <label class="debug-modal__label">Endpoint address</label>
        <p class="debug-modal__value" [class.debug-modal__value--custom]="isCustomEndpoint">
          {{ currentEndpoint }}
        </p>
        @if (isCustomEndpoint) {
          <button type="button" class="debug-modal__reset" (click)="resetEndpoint()">
            Restablecer endpoint por defecto
          </button>
        }
      </div>

      <div class="debug-modal__section">
        <label class="debug-modal__label">Set custom endpoint</label>
        <div class="debug-modal__input-group">
          <input
            type="text"
            pInputText
            [(ngModel)]="customEndpoint"
            placeholder="Ejemplo: http://192.168.XX.XX:PORT"
            class="debug-modal__input"
          />
        </div>
        <button
          type="button"
          class="debug-modal__set-btn"
          [disabled]="!customEndpoint.trim()"
          (click)="setEndpoint()"
        >
          Set endpoint
        </button>
      </div>

      <div class="debug-modal__footer">
        <button type="button" class="debug-modal__btn debug-modal__btn--secondary" (click)="close()">
          Cerrar
        </button>
        <button type="button" class="debug-modal__btn debug-modal__btn--primary" (click)="confirm()">
          Confirmar y recargar
        </button>
      </div>
    </div>
  </div>
}
